import { css } from '@emotion/core';

export const actionItemsStyles = css`
  height: 24px;
`;
